import { createSlice } from "@reduxjs/toolkit";

export const pageselectdata = createSlice({
    name: 'pageselectdata',

    initialState: {
        selectedPage: 'home'
    },

    reducers: {
        setPage: (state, page) => {
            state.selectedPage = page.payload
        }
    }
})

export const { setPage } = pageselectdata.actions
export default pageselectdata.reducer